import { mutationTypes } from './mutationUtils';
import React from 'react';
import Emm from './Emm';

export const songYannGorrig = {
  getTitle: () => ('Yann gorrig'),
  getLyrics: () => (
    <>
      Yann Gorrig <Emm mt={mutationTypes.MIXED}>o tañsal</Emm><br />
      Gant <Emm mt={mutationTypes.SOFT}>e droad</Emm> <Emm mt={mutationTypes.MIXED}>o tañsal</Emm><br />
      Gant <Emm mt={mutationTypes.SOFT}>e droad</Emm>, droad, droad<br />
      Gant <Emm mt={mutationTypes.SOFT}>e benn</Emm>, benn, benn<br />
      Gant e skoaz, skoaz, skoaz<br />
      Gant <Emm mt={mutationTypes.SOFT}>e vrec’h</Emm>, vrec’h, vrec’h<br />
      Gant <Emm mt={mutationTypes.SOFT}>e zorn</Emm>, zorn, zorn<br />
      Gant <Emm mt={mutationTypes.SOFT}>e viz</Emm>, viz, viz<br />
      ’Giz-se ’tañse Yann Gorrig.<br />
    </>
  ),
};

export const songMaligorn = {
  getTitle: () => ('Ur maligorn'),
  getLyrics: () => (
    <>
      Ur maligorn dindan ar glav<br />
      Fall eo an amzer,<br />
      'Benn warc'hoazh vo brav.<br />
      <Emm mt={mutationTypes.SOFT}>Daou valigorn</Emm> dindan ar glav...<br />
      Tri/Pevar/Pemp maligorn dindan ar glav...<br />
    </>
  ),
};

export const songTriFemoch = {
  getTitle: () => ('Tri femoc\'h bihan'),
  getLyrics: () => (
    <>
      <Emm mt={mutationTypes.SPIRANTE}>Tri femoc'h</Emm> bihan laouen,<br />
      <Emm mt={mutationTypes.SPIRANTE}>Tri femoc'h</Emm> e-barzh <Emm mt={mutationTypes.SPIRANTE}>o zi-maen</Emm>.<br />
                                                         Un, daou, tri, tri femoc'h bihan,<br />
      <Emm mt={mutationTypes.MIXED}>O tañsal</Emm> e-kichen an tan.<br />
    </>
  ),
};

export const songTriMartolod = {
  getTitle: () => ('Tri martolod'),
  getLyrics: () => (
    <>
      <em>Tri martolod</em> yaouank o voned <Emm mt={mutationTypes.SOFT}>da veajiñ</Emm><br />
                            Gant 'n avel bet kaset betek an Douar Nevez<br />
                            E-kichen mein <Emm mt={mutationTypes.SOFT_INCOMPLETE}>ar veilh</Emm> o deus mouilhet o eorioù<br />
                            Hag e-barzh ar veilh-se e oa ur servijourez<br />
                            Hag <Emm mt={mutationTypes.MIXED}>e c'houlenn</Emm> ganin pelec'h 'n eus graet konesañs<br />
                            E Naoned er marc'had hor boa choazet <Emm mt={mutationTypes.SOFT_INCOMPLETE}>ur walenn</Emm><br />
    </>
  ),
};

export const songDenvedAZo = {
  getTitle: () => ('Deñved a zo'),
  getLyrics: () => (
    <>
      Deñved a zo, met n'emaint ket <Emm mt={mutationTypes.SOFT_INCOMPLETE}>er gêr</Emm>.<br />
      Deñved a zo, met n'emaint ket <Emm mt={mutationTypes.SOFT_INCOMPLETE}>er vro</Emm>.<br />
      <Emm mt={mutationTypes.INCOMPLETE}>Ar c'hentañ</Emm> zo <Emm mt={mutationTypes.SOFT_INCOMPLETE}>er vag</Emm>.<br />
      An eil a zo <em>er mor</em>.<br />
      <em>An trede</em>, <em>ar pevare</em>, nann ne 'ez eus ket outo.<br />
    </>
  ),
};

export const songs = [ songMaligorn, songTriFemoch, songYannGorrig, songTriMartolod, songDenvedAZo ];
